import type { CredentialRowSummary } from "./credential-summaries";

/** A descriptive title followed by the identifier and the facts for this type.
 * Values wrap so a narrow vault never hides the distinguishing part of a name. */
export function CredentialSummaryLine({
  summary,
}: {
  summary: CredentialRowSummary;
}) {
  return (
    <span className="flex min-w-0 flex-1 flex-col gap-1.5">
      <span className="flex flex-wrap items-center gap-2">
        <span className="min-w-0 break-words text-sm font-semibold leading-snug text-slate-900 group-hover:text-primary">
          {summary.title}
        </span>
        {summary.meta && (
          <span className="rounded-full border border-slate-200 bg-white px-2 py-0.5 text-[11px] font-medium text-slate-600">
            {summary.meta}
          </span>
        )}
      </span>
      {(summary.identifier || (summary.secondary?.length ?? 0) > 0) && (
        <span className="flex flex-wrap items-baseline gap-x-3 gap-y-1 text-xs leading-relaxed text-slate-500">
          {summary.identifier && (
            <span className="break-all font-medium tabular-nums text-slate-700">
              {summary.identifier}
            </span>
          )}
          {summary.secondary?.map((fact) => (
            <span key={fact} className="min-w-0 break-words">
              {fact}
            </span>
          ))}
        </span>
      )}
    </span>
  );
}
